import _0x3fe4a8 from'./getNodeName.js';export default function isTableElement(_0x3f1c21){return['table','td','th']['indexOf'](_0x3fe4a8(_0x3f1c21))>=0x0;}